// // MODIFIED
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import AttachFileIcon from "@mui/icons-material/AttachFile"; // // ADDED
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import { ImageViewModal, PDFModal } from "../../../../../common/Modal";
import { StatusBadge } from "../../../../../common/Badge";

const LeaveRequestHistory = ({ isOpen, onClose, data = [] }) => {
  const [currentPage, setCurrentPage] = useState(1);

  // Modal States for viewing
  const [viewer, setViewer] = useState({ isOpen: false, data: null, type: "" });

  if (!isOpen) return null;

  const headers = ["Ref No.", "Type", "From", "To", "Days", "Status", "File", "Reason"];
  const accessors = ["referenceNumber", "leaveTypeDescription", "dateFrom", "dateTo", "days", "status", "content", "reason"];

  const handleViewFile = (row) => {
    const isPdf = row.fileName?.toLowerCase().endsWith(".pdf");
    console.log("Viewing file:", { row, isPdf });
    setViewer({
      isOpen: true,
      data: row.content,
      type: isPdf ? "application/pdf" : "image/jpeg"
    });
  };

  const customRender = (row, accessor) => {
    if (accessor === "referenceNumber") return `LV-${row[accessor]?.toString().padStart(6, "0")}`;
    if (accessor === "dateFrom" || accessor === "dateTo") {
      return row[accessor] ? new Date(row[accessor]).toLocaleDateString() : "-";
    }
    if (accessor === "status") {
      return <StatusBadge status={row[accessor]} />;
    }
    if (accessor === "content") {
      return row[accessor] ? (
        <button
          onClick={() => handleViewFile(row)}
          className="bg-transparent border-none text-blue-500 cursor-pointer hover:text-blue-700"
        >
          <AttachFileIcon fontSize="small" />
        </button>
      ) : "-";
    }
    return null;
  };
  console.log("Leave Request History Data:", data);
  return (
    <>
      <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 text-gray-700 overflow-auto">
        <div className="bg-gray-50 w-full md:w-[95%] lg:w-[85%] rounded-lg shadow-xl h-auto max-h-[90vh] flex flex-col relative">
          <div className="flex justify-between items-center px-6 py-3 border-b border-gray-200 bg-white rounded-t-lg">
            <h2 className="text-xl font-semibold text-gray-500 tracking-tight">Leave Filed History</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-700 bg-transparent border-none cursor-pointer"><CloseIcon fontSize="medium" /></button>
          </div>

          <div className="p-6 overflow-y-auto">
            <CreateTable
              headers={headers} accessors={accessors} data={data}
              currentPage={currentPage} setCurrentPage={setCurrentPage}
              itemsPerPage={10} totalItems={data.length} customCellRenderer={customRender}
            />
          </div>

          <div className="flex justify-end p-4 border-t bg-white rounded-b-lg">
            <button onClick={onClose} className="bg-gray-500 text-white px-6 py-2 rounded cursor-pointer border-none">Close</button>
          </div>
        </div>
      </div>

      {/* Preview Modals */}
      {viewer.type === "application/pdf" ? (
        <PDFModal
          visible={viewer.isOpen}
          onClose={() => setViewer({ ...viewer, isOpen: false })}
          fileUrl={`data:application/pdf;base64,${viewer.data}`}
        />
      ) : (
        <ImageViewModal
          isOpen={viewer.isOpen}
          onClose={() => setViewer({ ...viewer, isOpen: false })}
          fileData={viewer.data}
          fileType={viewer.type}
        />
      )}
    </>
  );
};

export default LeaveRequestHistory;